query AvailableOrganizationsAutocomplete(
  $input: String = ""
  $value: [ID!] = []
) {
  autocomplete: autocompleteAvailableOrganizations(
    input: $input
    value: $value
  ) {
    options {
      value
      label
    }
    value {
      value
      label
    }
  }
}

